import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { fetchFooterTicker } from '../actions'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Typography } from '@mui/material'
import { Ribbon } from 'frame/components'
import PhoneIcon from '@mui/icons-material/Phone'
import { themeV5 } from 'theme/v5'

const Footer = ({ flags, selectedFleets, footerTicker, onFetchFooterTicker }) => {

  const mobileView = useMediaQuery('(max-width: 600px)')

  const [key] = useState(1)
  const [delayLoading, setDelayLoading] = useState(true)

  const isDoneFetching = flags?.fetchFooterTicker === 'processed'
    && flags?.checkHaveAppUsers === 'processed'
    && flags?.fetchNotifications === 'processed'
    && flags?.fetchStatusUpdates === 'processed'
    && flags?.fetchIndustryNews === 'processed'
    && flags?.fetchContactDetails === 'processed'

  // render ticker after page is fully loaded
  const showTicker = !delayLoading && footerTicker && footerTicker.length > 0

  useEffect(() => {
    onFetchFooterTicker()
  }, [onFetchFooterTicker])

  useEffect(() => {
    isDoneFetching && setTimeout(() => {
      setDelayLoading(false)
    }, 1500)
  }, [isDoneFetching])

  const tickerTextConfig = footerTicker.map(({ title, fleets }) =>
    fleets && fleets.length > 0
      ? fleets.every(fleetId => selectedFleets.includes(fleetId)) // check if fleetids in fleets is part of currently selected fleets
        ? title : null
      : title
  )

  // const scrolling = useSpring({
  //   from: { transform: 'translate(60%, 0)' },
  //   to: { transform: 'translate(-60%, 0)' },
  //   config: { duration: 30000 }, // footer sliding text speed
  //   reset: true,
  //   onRest: () => setKey(key + 1)
  // })

  const footerLinksConfig = [
    { label: 'Fleet Enquiry', path: 'https://toyotafleetmanagement.co.nz/toyota-fleet-management-contact' },
    { label: 'General Enquiry', path: 'https://toyotafleetmanagement.co.nz/toyota-fleet-management-contact' },
    { label: 'Subscribe Here', path: 'http://live.tfs.co.nz/Indicator-Newsletter-Subscribe_Indicator-Newsletter-Subscription-List.html' },
    { label: '0800 GO FLEET', path: 'tel:+0800463533', Icon: PhoneIcon, addLineBreak: true }
  ]

  return (
    <>
      <div
        style={{
          maxHeight: 40,
        }}>
        <Ribbon
          backgroundColor="#012A46"
          customChildren={
            <div
              key={key}
              style={{
                whiteSpace: 'nowrap',
                minHeight: 22,
              }}>
              {showTicker && (
                <div>
                  <Typography variant="body2">
                    {tickerTextConfig.length > 0 && tickerTextConfig.map((text, index) => (
                      <span
                        key={`ticker-${index}`}
                        style={{
                          fontSize: '15px',
                          letterSpacing: 0,
                          lineHeight: '22px',
                        }}>
                        {text}
                        {index !== tickerTextConfig.length - 1 && (
                          <span
                            style={{
                              margin: '0 100px'
                            }}>|</span>
                        )}
                      </span>
                    ))}
                  </Typography>
                </div>
              )}
            </div>
          }/>
      </div>

      <Ribbon
        backgroundColor="#FFF"
        customChildren={
          <Typography variant="body2">

            {footerLinksConfig.map(({ label, path, Icon, addLineBreak }, index) => (
              <span key={`footer-link-${index}`}>
                {addLineBreak && mobileView && (
                  <br />
                )}

                {Icon && (
                  <Icon
                    sx={{
                      position: 'relative',
                      top: 2,
                      marginRight: '10px',
                      fontSize: 16,
                      color: themeV5.palette.brand.red,
                    }}/>
                )}

                <a href={path} rel="noopener noreferrer" target="_blank"
                  style={{
                    textDecoration: 'none',
                    fontSize: '15px',
                    lineHeight: '22px',
                    color: '#000000',
                    '&:hover': {
                      color: themeV5.palette.brand.red,
                    },
                  }}>
                  {label}
                </a>

                {index !== footerLinksConfig.length - 1 && (
                  <span
                    style={{
                      margin: '0 20px',
                      color: themeV5.palette.brand.red,
                      fontSize: '15px'
                    }}>|</span>
                )}
              </span>
            ))}
          </Typography>
        }/>
    </>
  )
}

Footer.propTypes = {
  flags: PropTypes.object,
  selectedFleets: PropTypes.array.isRequired,
  footerTicker: PropTypes.array,
  onFetchFooterTicker: PropTypes.func.isRequired,
}

const mapStateToProps = ({ homepage, settings }) => ({
  flags: homepage?.flags,
  footerTicker: homepage?.footerTicker || [],
  selectedFleets: settings.fleet.selected,
})

const mapDispatchToProps = (dispatch) => ({
  onFetchFooterTicker: () => dispatch(fetchFooterTicker()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Footer)

